export default __webpack_public_path__ + "static/media/ba4c6b4d4ea19b20.656c8959c9095362c886dfadb474b7f8.svg";